import { render, staticRenderFns } from "./Default.vue?vue&type=template&id=4c869523&scoped=true"
import script from "./Default.vue?vue&type=script&lang=js"
export * from "./Default.vue?vue&type=script&lang=js"
import style0 from "./Default.vue?vue&type=style&index=0&id=4c869523&prod&lang=scss&scoped=true"
import style1 from "./Default.vue?vue&type=style&index=1&id=4c869523&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c869523",
  null
  
)

export default component.exports